import baseHttpService from "core/http/singleton/base";
import {
  FileLaborContract,
  LaborContract,
  ProfileWork,
  ProfileWorkBefore,
} from "./resTypes";
import {
  geLaborContractUrl,
  getFileLaborContractUrl,
  getProfileWorkBeforeUrl,
  getProfileWorkUrl,
  updateProfileWorkBeforeUrl,
} from "./urls";

export const getProfileWorkBeforeApi = async (): Promise<
  ProfileWorkBefore[]
> => {
  const res = await baseHttpService.get<ProfileWorkBefore[]>(
    getProfileWorkBeforeUrl
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const updateProfileWorkBeforeApi = async (
  payload: ProfileWorkBefore[]
): Promise<any> => {
  const res = await baseHttpService.put<any>(
    updateProfileWorkBeforeUrl("IP_010"),
    payload
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getProfileWorkApi = async (): Promise<ProfileWork[]> => {
  const res = await baseHttpService.get<ProfileWork[]>(getProfileWorkUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getLaborContractApi = async (): Promise<LaborContract[]> => {
  const res = await baseHttpService.get<LaborContract[]>(geLaborContractUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getFileLaborContractApi = async (
  laborContractId: string
): Promise<FileLaborContract> => {
  const res = await baseHttpService.get<FileLaborContract>(
    getFileLaborContractUrl(laborContractId)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
